import HcOffcanvasNav from 'hc-offcanvas-nav';
export default function initResponsiveMenu() {
  var logo = document.createElement('img');
  logo.src = wpAmitieNature.siteLogoUrl;
  logo.alt = wpAmitieNature.siteTitle;
  logo.width = 150;
  new HcOffcanvasNav("#site-navigation", {
    position: 'left',
    disableAt: 992,
    customToggle: '.menu-toggle',
    showNavTitle: true,
    navTitle: logo
  });
}